export default __webpack_public_path__ + "static/media/error.b0a5b6f6.svg";